import React, { FC, memo, useMemo } from 'react'
import { Button } from '@ucheba/ui/components/Button/desktop'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'
import PlayIcon from '@ucheba/ui/icons/icon__circled-play.svg'
import { EColorBgText } from '@ucheba/utils/helpers/styles/variables'
import { useAllowedChannels } from '@ucheba/utils/hooks/useAllowedChannels'
import { EMessengerChannel, EMessengerType } from '@ucheba/store/profile/types'
import { analyticEvent } from '@ucheba/utils/helpers/analytics/events'
import {
  EAnalyticEvents,
  EAnalyticEventTargets,
  EAnalyticSections,
} from '@ucheba/utils/helpers/analytics/events/types'
import { EButtonColorByTheme } from '../../../../Banner/types'
import { EEventFormat, EEventRegisteredStatus } from '../../../../EventsList/types'
import { useEventsListItemCore, useEventsListItemDate } from '../../../../EventsList/bll'
import EventsPageRegisterNotStartedEventNotice from '../../EventNotices/EventsRegisterNotStartedEventNotice/desktop'
import EventsPageRegisterStartedEventNotice from '../../EventNotices/EventsRegisterStartedEventNotice/desktop'
import EventsPageRegisterOfflineEventNotice from '../../EventNotices/EventsRegisterOfflineEventNotice/desktop'
import EventNoticeNotAllowedMessage from '../../EventNotices/EventNoticeNotAllowedMessage/desktop'
import { IEventsRegistration } from '../types'

const EventsRegistration: FC<IEventsRegistration> = (props) => {
  const { streamUrl, branding, formats, id, onClickAction } = props

  const isAllowedMess = useAllowedChannels([
    EMessengerChannel.vk_ucheba,
    EMessengerChannel.telegram_ucheba,
  ])

  const {
    buttonData,
    onClickRegistration,
    registersPending,
    notices,
    isEventStartedOrHour,
  } = useEventsListItemCore({ ...props, isAllowedMess })
  const { format, date } = useEventsListItemDate(props)

  const newDate = date?.split(',')

  const dateForEvent7009 = useMemo(() => {
    if (id === 7009) {
      return '3-7 июня'
    }

    return null
  }, [id])

  const isHybridEvent = useMemo(() => {
    return (
      formats.some((val) => val.value === EEventFormat.online) &&
      formats.some((val) => val.value === EEventFormat.offline)
    )
  }, [formats])

  return (
    <>
      <EventsPageRegisterNotStartedEventNotice
        id={id}
        open={!!notices.onlineEventNotStartedNotice.open}
        isHybrid={isHybridEvent}
      />

      <EventsPageRegisterStartedEventNotice
        id={id}
        href={streamUrl}
        open={!!notices.onlineEventStartedNotice.open}
      />

      <EventsPageRegisterOfflineEventNotice
        id={id}
        open={!!notices.offlineEventNotice.open}
        isEventStarted={isEventStartedOrHour}
      />

      <EventNoticeNotAllowedMessage
        id={id}
        open={!!notices.notAllowedMessegerNotice.open}
        isHybrid={isHybridEvent}
        isOnline={formats.some((val) => val.value === EEventFormat.online)}
        onClose={notices.notAllowedMessegerNotice.removeNotice}
      />

      <Button
        color={
          branding?.headerBackgroundColor
            ? EButtonColorByTheme[branding.headerBackgroundColor]
            : 'blue'
        }
        block
        onClick={() => {
          if (onClickAction) {
            onClickAction(id)
          } else {
            analyticEvent({
              targets: [
                EAnalyticEventTargets.ym,
                EAnalyticEventTargets.ga,
                EAnalyticEventTargets.ur,
              ],
              eventName: EAnalyticEvents.eventRegistrationClick,
              section: EAnalyticSections.eventRegistrationClick,
            })

            onClickRegistration()
          }
        }}
        progress={registersPending}
        target='_blank'
        StartIcon={
          buttonData.eventRegisteredStatus === EEventRegisteredStatus.watchBroadcast &&
          streamUrl ? (
            <PlayIcon width='20px' height='20px' />
          ) : null
        }
        href={
          buttonData.eventRegisteredStatus === EEventRegisteredStatus.watchBroadcast
            ? streamUrl
            : undefined
        }
      >
        {buttonData.eventRegisteredStatus === EEventRegisteredStatus.watchBroadcast
          ? 'Смотреть'
          : buttonData.buttonText}
      </Button>

      <Spacing spacing='xsmall' />

      {dateForEvent7009 && (
        <>
          <div style={{ fontWeight: 'bold' }}>{dateForEvent7009}</div>

          <Spacing spacing='usmall' />
        </>
      )}

      {!dateForEvent7009 && date && (
        <>
          {newDate && newDate[0] && (
            <div style={{ fontWeight: 'bold' }}>{newDate[0]}</div>
          )}

          <Spacing spacing='usmall' />

          {newDate && newDate[1] && (
            <div style={{ fontWeight: 'bold' }}>{newDate[1]}</div>
          )}

          <Spacing spacing='usmall' />
        </>
      )}

      {format && (
        <>
          <Text
            fontWeight='bold'
            color={
              branding?.headerBackgroundColor
                ? EColorBgText[branding.headerBackgroundColor]
                : 'black'
            }
          >
            {format}
          </Text>

          <Spacing spacing='usmall' />
        </>
      )}
    </>
  )
}

export default memo(EventsRegistration)
